import { apiClient } from "./apiClient";

export interface FilaSalgadaDescricao {
  order_id?: number;
  display_id?: number;
  item_original_name?: string | null;
  name: string;
  quantidade: number;
  borda: string | null;
  sabores: string[];
  acrescimos?: string[];
  observacao: string | null;
  tamanhoSelecionado?: boolean;
  tamanhoOpcao?: "08" | "broto";
}

export interface FilaSalgadaItem {
  id: number;
  pedidoIntegracaoId: number;
  displayId: number;
  orderId: number;
  itemsSalgados: any;
  descricao: FilaSalgadaDescricao[];
  status: string;
  observation?: string | null;
  createdAt: string;
  updatedAt: string;
  pedidoIntegracao?: {
    customerName: string | null;
    deliveryAddress: any;
    orderType: string | null;
    observation: string | null;
    internalObservation?: string | null;
    statusIntegracao?: string | null;
  };
  assignedToUser?: { id: number; nome: string } | null;
}

export interface FilaDoceDescricao {
  order_id?: number;
  display_id?: number;
  item_original_name?: string | null;
  name: string;
  quantidade: number;
  borda: string | null;
  sabores: string[];
  acrescimos?: string[];
  observacao: string | null;
  tamanhoSelecionado?: boolean;
  tamanhoOpcao?: "08" | "broto";
}

export interface FilaDoceItem {
  id: number;
  pedidoIntegracaoId: number;
  displayId: number;
  orderId: number;
  itemsDoces: any;
  descricao: FilaDoceDescricao[];
  status: string;
  observation?: string | null;
  createdAt: string;
  updatedAt: string;
  pedidoIntegracao?: {
    customerName: string | null;
    deliveryAddress: any;
    orderType: string | null;
    observation: string | null;
    internalObservation?: string | null;
    statusIntegracao?: string | null;
  };
  assignedToUser?: { id: number; nome: string } | null;
}

export type PizzaioloFilaTipo =
  | "salgada"
  | "doce"
  | "salao_salgada"
  | "salao_doce"
  | "rodizio_salgada"
  | "rodizio_doce";

export interface PedidoFoodflyResumo {
  identificador: string | null;
  mesaId?: string | null;
  comandaId?: string | null;
  observacao: string | null;
  numeroPedido: number;
}

/** Pedido a priorizar na montagem: Cardápio Web ou salão (FoodFly). */
export type PrioridadeMontagemAlvo =
  | { pedidoIntegracaoId: number; pedidoFoodflyId?: undefined }
  | { pedidoFoodflyId: number; pedidoIntegracaoId?: undefined };

export const prioridadeMontagemKey = (alvo: PrioridadeMontagemAlvo): string =>
  alvo.pedidoFoodflyId != null
    ? `salao:${alvo.pedidoFoodflyId}`
    : `web:${alvo.pedidoIntegracaoId}`;

export interface AssignedItem {
  id: number;
  tipo: PizzaioloFilaTipo;
  pedidoIntegracaoId: number | null;
  pedidoFoodflyId?: number | null;
  displayId: number;
  orderId: number;
  descricao: FilaSalgadaDescricao[] | FilaDoceDescricao[];
  observation: string | null;
  status: string;
  assignedToUserId: number | null;
  startedAt: string | null;
  createdAt: string;
  pedidoIntegracao?: {
    customerName: string | null;
    deliveryAddress: any;
    orderType: string | null;
    observation: string | null;
  };
  pedidoFoodfly?: PedidoFoodflyResumo | null;
}

export interface MinhasEstatisticasFilaDia {
  quantidade: number;
  tempoMedioSegundos: number;
}

export interface EmAbertoFilaItem {
  filaId: number;
  displayId: number;
  orderId: number;
  status: string;
  etapaLabel: string;
  situacaoDesde?: string;
}

export interface EmAbertoHojeDetalhes {
  salgada: EmAbertoFilaItem[];
  doce: EmAbertoFilaItem[];
  salao_salgada: EmAbertoFilaItem[];
  salao_doce: EmAbertoFilaItem[];
}

export interface MeuStatusResponse {
  isOnline: boolean;
  isFilaSalgada: boolean;
  isFilaDoce: boolean;
  isFilaSalaoSalgada?: boolean;
  isFilaSalaoDoce?: boolean;
  isFilaRodizioSalgada?: boolean;
  isFilaRodizioDoce?: boolean;
  currentItem: AssignedItem | null;
  pendingSalgada: number;
  pendingDoce: number;
  pendingSalaoSalgada?: number;
  pendingSalaoDoce?: number;
  completedSalgada: number;
  completedDoce: number;
  completedSalaoSalgada?: number;
  completedSalaoDoce?: number;
  minhasEstatisticas?: {
    salgada: MinhasEstatisticasFilaDia;
    doce: MinhasEstatisticasFilaDia;
    salao_salgada?: MinhasEstatisticasFilaDia;
    salao_doce?: MinhasEstatisticasFilaDia;
  };
  emAberto?: EmAbertoHojeDetalhes;
  cancelledItems: CancelledItemAlert[];
}

export interface CancelledItemAlert {
  id: number;
  tipo: PizzaioloFilaTipo;
  orderId: number;
  displayId: number;
}

export function isFilaSalgadaFamilia(tipo: PizzaioloFilaTipo): boolean {
  return (
    tipo === "salgada" ||
    tipo === "salao_salgada" ||
    tipo === "rodizio_salgada"
  );
}

export function isFilaDoceFamilia(tipo: PizzaioloFilaTipo): boolean {
  return tipo === "doce" || tipo === "salao_doce" || tipo === "rodizio_doce";
}

export function isFilaSalaoTipo(tipo: PizzaioloFilaTipo): boolean {
  return tipo === "salao_salgada" || tipo === "salao_doce";
}

export function isFilaRodizioTipo(tipo: PizzaioloFilaTipo): boolean {
  return tipo === "rodizio_salgada" || tipo === "rodizio_doce";
}

export function filaTipoLabel(tipo: PizzaioloFilaTipo): string {
  switch (tipo) {
    case "salgada":
      return "Salgada";
    case "doce":
      return "Doce";
    case "salao_salgada":
      return "Salão Salgada";
    case "salao_doce":
      return "Salão Doce";
    case "rodizio_salgada":
      return "Rodízio Salgada";
    case "rodizio_doce":
      return "Rodízio Doce";
  }
}

export interface FinalizarResponse {
  finalized: AssignedItem;
  nextItem: AssignedItem | null;
}

export interface PedidoIntegracaoOption {
  name: string;
  quantity: number;
  option_id: number;
  unit_price: number;
  external_code: string | null;
  option_group_id: number;
  option_group_name: string;
  option_group_total_selected_options: number | null;
}

export interface PedidoIntegracaoItem {
  kind: string;
  name: string;
  items: any[];
  status: string;
  item_id: number;
  options: PedidoIntegracaoOption[];
  quantity: number;
  unit_price: number;
  observation: string | null;
  total_price: number;
  external_code: string | null;
  order_item_id: number;
}

export interface PedidoIntegracao {
  id: number;
  orderId: number;
  displayId: number | null;
  customerName: string | null;
  customerPhone: string | null;
  deliveryAddress: any;
  orderType: string | null;
  observation: string | null;
  total: number | null;
  deliveryFee: number | null;
  items: PedidoIntegracaoItem[];
  createdAt: string;
  /** Presente quando o pedido veio do FoodFly (salão). */
  canalOrigem?: "cardapio" | "salao";
  salaoMesaId?: string | null;
  salaoComandaId?: string | null;
}

export const BRINDE_CATEGORIAS = [
  "Marketing",
  "Processo",
  "Cortesia",
  "Motoboy",
  "Outros",
] as const;

export type BrindeCategoria = (typeof BRINDE_CATEGORIAS)[number];

export interface RelatorioBrindePizzasLinha {
  lojaId: number | null;
  lojaNome: string;
  tamanhoNome: string;
  saborNome: string;
  motivo: string;
  categoria: string;
  quantidade: number;
}

export const RELATORIO_BRINDE_PAGE_SIZE = 50;

export interface RelatorioBrindePizzasPaginatedResponse {
  data: RelatorioBrindePizzasLinha[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  totalQuantidadeGeral: number;
  totalQuantidadePagina: number;
}

export interface FilaEstatisticasBloco {
  pendentes: number;
  emMontagem: number;
  finalizadas: number;
  total: number;
}

export interface FilaEstatisticas {
  filaDoce: FilaEstatisticasBloco;
  filaSalgada: FilaEstatisticasBloco;
  filaSalaoDoce?: FilaEstatisticasBloco;
  filaSalaoSalgada?: FilaEstatisticasBloco;
}

export interface PaginatedFilaResponse<T> {
  data: T[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface RodizioResponse {
  createdCount: number;
}

export interface RodizioEstadoResponse {
  lojaId: number;
  salgada: {
    proximoIndice: number;
    proximoSabor: string | null;
    isUrgente?: boolean;
    proximoSaborSequencia?: string | null;
  };
  doce: {
    proximoIndice: number;
    proximoSabor: string | null;
    isUrgente?: boolean;
    proximoSaborSequencia?: string | null;
  };
}

export interface RodizioUrgenciaItem {
  id: number;
  saborNome: string;
  isUrgente: boolean;
  status: string;
  displayId: number;
  createdAt: string;
}

export interface RodizioSaborItem {
  id: number;
  tipo: "salgada" | "doce";
  nome: string;
  ordem: number;
}

export const filaPizzasService = {
  getFilaSalgada: async (params?: {
    status?: string;
    lojaId?: number;
    todasLojas?: boolean;
    data?: string;
    displayId?: string | number;
    orderId?: string | number;
    page?: number;
    limit?: number;
  }): Promise<PaginatedFilaResponse<FilaSalgadaItem>> => {
    const query = new URLSearchParams();
    if (params?.status) query.append("status", params.status);
    if (params?.lojaId != null) query.append("lojaId", String(params.lojaId));
    if (params?.todasLojas) query.append("todasLojas", "true");
    if (params?.data) query.append("data", params.data);
    if (params?.displayId != null && params.displayId !== "")
      query.append("displayId", String(params.displayId));
    if (params?.orderId != null && params.orderId !== "")
      query.append("orderId", String(params.orderId));
    if (params?.page) query.append("page", String(params.page));
    if (params?.limit) query.append("limit", String(params.limit));
    const suffix = query.toString() ? `?${query.toString()}` : "";
    return apiClient.get(`/fila-pizzas/salgada${suffix}`);
  },

  getFilaDoce: async (params?: {
    status?: string;
    lojaId?: number;
    todasLojas?: boolean;
    data?: string;
    displayId?: string | number;
    orderId?: string | number;
    page?: number;
    limit?: number;
  }): Promise<PaginatedFilaResponse<FilaDoceItem>> => {
    const query = new URLSearchParams();
    if (params?.status) query.append("status", params.status);
    if (params?.lojaId != null) query.append("lojaId", String(params.lojaId));
    if (params?.todasLojas) query.append("todasLojas", "true");
    if (params?.data) query.append("data", params.data);
    if (params?.displayId != null && params.displayId !== "")
      query.append("displayId", String(params.displayId));
    if (params?.orderId != null && params.orderId !== "")
      query.append("orderId", String(params.orderId));
    if (params?.page) query.append("page", String(params.page));
    if (params?.limit) query.append("limit", String(params.limit));
    const suffix = query.toString() ? `?${query.toString()}` : "";
    return apiClient.get(`/fila-pizzas/doce${suffix}`);
  },

  getFilaSalaoSalgada: async (params?: {
    status?: string;
    lojaId?: number;
    todasLojas?: boolean;
    data?: string;
    displayId?: string | number;
    orderId?: string | number;
    page?: number;
    limit?: number;
  }): Promise<PaginatedFilaResponse<AssignedItem>> => {
    const query = new URLSearchParams();
    if (params?.status) query.append("status", params.status);
    if (params?.lojaId != null) query.append("lojaId", String(params.lojaId));
    if (params?.todasLojas) query.append("todasLojas", "true");
    if (params?.data) query.append("data", params.data);
    if (params?.displayId != null && params.displayId !== "")
      query.append("displayId", String(params.displayId));
    if (params?.orderId != null && params.orderId !== "")
      query.append("orderId", String(params.orderId));
    if (params?.page) query.append("page", String(params.page));
    if (params?.limit) query.append("limit", String(params.limit));
    const suffix = query.toString() ? `?${query.toString()}` : "";
    return apiClient.get(`/fila-pizzas/salao-salgada${suffix}`);
  },

  getFilaSalaoDoce: async (params?: {
    status?: string;
    lojaId?: number;
    todasLojas?: boolean;
    data?: string;
    displayId?: string | number;
    orderId?: string | number;
    page?: number;
    limit?: number;
  }): Promise<PaginatedFilaResponse<AssignedItem>> => {
    const query = new URLSearchParams();
    if (params?.status) query.append("status", params.status);
    if (params?.lojaId != null) query.append("lojaId", String(params.lojaId));
    if (params?.todasLojas) query.append("todasLojas", "true");
    if (params?.data) query.append("data", params.data);
    if (params?.displayId != null && params.displayId !== "")
      query.append("displayId", String(params.displayId));
    if (params?.orderId != null && params.orderId !== "")
      query.append("orderId", String(params.orderId));
    if (params?.page) query.append("page", String(params.page));
    if (params?.limit) query.append("limit", String(params.limit));
    const suffix = query.toString() ? `?${query.toString()}` : "";
    return apiClient.get(`/fila-pizzas/salao-doce${suffix}`);
  },

  finalizarSalgada: async (
    id: number
  ): Promise<{ success: boolean; filaSalgada: FilaSalgadaItem }> => {
    return apiClient.post(`/fila-pizzas/salgada/${id}/finalizar`, {});
  },

  finalizarDoce: async (
    id: number
  ): Promise<{ success: boolean; filaDoce: FilaDoceItem }> => {
    return apiClient.post(`/fila-pizzas/doce/${id}/finalizar`, {});
  },

  patchItemObservacao: async (
    tipo: "salgada" | "doce" | "salao_salgada" | "salao_doce",
    filaId: number,
    itemIndex: number,
    observacao: string | null
  ): Promise<{
    success: boolean;
    filaDoce?: FilaDoceItem;
    filaSalgada?: FilaSalgadaItem;
  }> => {
    const path = tipo.replace("_", "-");
    return apiClient.patch(`/fila-pizzas/${path}/${filaId}/item-observacao`, {
      itemIndex,
      observacao,
    });
  },

  getEstatisticas: async (params?: {
    data?: string;
    lojaId?: number;
    todasLojas?: boolean;
  }): Promise<FilaEstatisticas> => {
    const query = new URLSearchParams();
    if (params?.data) query.append("data", params.data);
    if (params?.lojaId != null) query.append("lojaId", String(params.lojaId));
    if (params?.todasLojas) query.append("todasLojas", "true");
    const suffix = query.toString() ? `?${query.toString()}` : "";
    return apiClient.get(`/fila-pizzas/estatisticas${suffix}`);
  },

  getRelatorioBrindePizzas: async (filters: {
    dataInicio: string;
    dataFim: string;
    lojaId?: number | null;
    tamanhoId?: number | null;
    categoria?: BrindeCategoria | null;
    motivoContains?: string;
    saborContains?: string;
  }): Promise<RelatorioBrindePizzasLinha[]> => {
    const qs = new URLSearchParams();
    qs.append("dataInicio", filters.dataInicio);
    qs.append("dataFim", filters.dataFim);
    if (filters.lojaId != null && filters.lojaId !== undefined) {
      qs.append("lojaId", String(filters.lojaId));
    }
    if (filters.tamanhoId != null && filters.tamanhoId !== undefined) {
      qs.append("tamanhoId", String(filters.tamanhoId));
    }
    if (filters.categoria) {
      qs.append("categoria", filters.categoria);
    }
    if (filters.motivoContains?.trim()) {
      qs.append("motivoContains", filters.motivoContains.trim());
    }
    if (filters.saborContains?.trim()) {
      qs.append("saborContains", filters.saborContains.trim());
    }
    return apiClient.get(`/fila-pizzas/relatorio-brinde?${qs}`);
  },

  getRelatorioBrindePizzasPaginated: async (
    filters: {
      dataInicio: string;
      dataFim: string;
      lojaId?: number | null;
      tamanhoId?: number | null;
      categoria?: BrindeCategoria | null;
      motivoContains?: string;
      saborContains?: string;
    },
    page: number,
    limit: number = RELATORIO_BRINDE_PAGE_SIZE
  ): Promise<RelatorioBrindePizzasPaginatedResponse> => {
    const qs = new URLSearchParams();
    qs.append("dataInicio", filters.dataInicio);
    qs.append("dataFim", filters.dataFim);
    qs.append("page", String(page));
    qs.append("limit", String(limit));
    if (filters.lojaId != null && filters.lojaId !== undefined) {
      qs.append("lojaId", String(filters.lojaId));
    }
    if (filters.tamanhoId != null && filters.tamanhoId !== undefined) {
      qs.append("tamanhoId", String(filters.tamanhoId));
    }
    if (filters.categoria) {
      qs.append("categoria", filters.categoria);
    }
    if (filters.motivoContains?.trim()) {
      qs.append("motivoContains", filters.motivoContains.trim());
    }
    if (filters.saborContains?.trim()) {
      qs.append("saborContains", filters.saborContains.trim());
    }
    return apiClient.get(`/fila-pizzas/relatorio-brinde-paginado?${qs}`);
  },

  reprocessarPendentes: async (): Promise<{
    success: boolean;
    processados: number;
    doces: number;
    salgadas: number;
  }> => {
    return apiClient.post("/fila-pizzas/reprocessar-pendentes", {});
  },

  getMeuStatus: async (options?: {
    tryAssign?: boolean;
  }): Promise<MeuStatusResponse> => {
    const assign = options?.tryAssign === false ? "false" : undefined;
    const query = assign != null ? `?assign=${assign}` : "";
    return apiClient.get(`/pizzaiolo-integracao/meu-status${query}`);
  },

  ficarOnline: async (): Promise<MeuStatusResponse> => {
    return apiClient.post("/pizzaiolo-integracao/online", {});
  },

  ficarOffline: async (): Promise<MeuStatusResponse> => {
    return apiClient.post("/pizzaiolo-integracao/offline", {});
  },

  finalizarProducaoIntegracao: async (
    id: number,
    tipo: PizzaioloFilaTipo,
    tempoTotal: number
  ): Promise<FinalizarResponse> => {
    return apiClient.post(
      `/pizzaiolo-integracao/finalizar/${id}/${tipo}`,
      { tempoTotal },
      { timeoutMs: 120_000 }
    );
  },

  definirTamanhoRodizioItem: async (
    id: number,
    tipo: "rodizio_salgada" | "rodizio_doce",
    tamanho: "08" | "broto"
  ): Promise<AssignedItem> => {
    return apiClient.post(`/pizzaiolo-integracao/rodizio/item/${id}/tamanho`, {
      tipo,
      tamanho,
    });
  },

  pularItem: async (
    itemId: number,
    tipo: PizzaioloFilaTipo,
    motivo: string
  ): Promise<{ nextItem: AssignedItem | null }> => {
    return apiClient.post("/pizzaiolo-integracao/pular-item", {
      itemId,
      tipo,
      motivo,
    });
  },

  atualizarPreferencias: async (data: {
    isFilaSalgada?: boolean;
    isFilaDoce?: boolean;
    isFilaSalaoSalgada?: boolean;
    isFilaSalaoDoce?: boolean;
    isFilaRodizioSalgada?: boolean;
    isFilaRodizioDoce?: boolean;
  }): Promise<{
    isFilaSalgada: boolean;
    isFilaDoce: boolean;
    isFilaSalaoSalgada: boolean;
    isFilaSalaoDoce: boolean;
    isFilaRodizioSalgada: boolean;
    isFilaRodizioDoce: boolean;
    isOnlineIntegracao: boolean;
  }> => {
    return apiClient.put("/pizzaiolo-integracao/preferencias", data);
  },

  priorizarMontagem: async (alvo: PrioridadeMontagemAlvo): Promise<any> => {
    return apiClient.post("/pizzaiolo-integracao/priorizar-montagem", alvo);
  },

  /** Chaves de `prioridadeMontagemKey` (Cardápio Web e salão FoodFly). */
  getPrioridadesMontagem: async (params?: {
    lojaId?: number;
  }): Promise<string[]> => {
    const lojaId = params?.lojaId;
    const suffix = lojaId != null ? `?lojaId=${lojaId}` : "";
    const res: {
      pedidoIntegracaoIds?: number[];
      pedidoFoodflyIds?: number[];
    } = await apiClient.get(
      `/pizzaiolo-integracao/prioridades-montagem/por-origem${suffix}`
    );
    return [
      ...(res?.pedidoIntegracaoIds ?? []).map((id) =>
        prioridadeMontagemKey({ pedidoIntegracaoId: id })
      ),
      ...(res?.pedidoFoodflyIds ?? []).map((id) =>
        prioridadeMontagemKey({ pedidoFoodflyId: id })
      ),
    ];
  },

  removerPrioridadeMontagem: async (
    alvo: PrioridadeMontagemAlvo
  ): Promise<any> => {
    return apiClient.post(
      "/pizzaiolo-integracao/remover-prioridade-montagem",
      alvo
    );
  },

  getPedidoOriginal: async (
    orderId: number,
    lojaId?: number
  ): Promise<PedidoIntegracao | null> => {
    const qs =
      lojaId != null && Number.isFinite(lojaId) ? `?lojaId=${lojaId}` : "";
    return apiClient.get(`/pizzaiolo-integracao/pedido/${orderId}${qs}`);
  },

  criarRodizio: async (data: {
    tamanhoId: number;
    quantidade: number;
  }): Promise<RodizioResponse> => {
    return apiClient.post("/pizzaiolo-integracao/rodizio", data);
  },

  finalizarRodizioSalgado: async (data: {
    tamanhoId: number;
    tempoTotal: number;
  }): Promise<RodizioResponse> => {
    return apiClient.post(
      "/pizzaiolo-integracao/rodizio/salgado/finalizar",
      data
    );
  },

  finalizarSalao: async (data: {
    tamanhoId: number;
    bordaId: number;
    tempoTotal: number;
  }): Promise<RodizioResponse> => {
    return apiClient.post("/pizzaiolo-integracao/salao/finalizar", data);
  },

  listRodizioSabores: async (
    tipo: "salgada" | "doce"
  ): Promise<RodizioSaborItem[]> => {
    return apiClient.get(`/pizzaiolo-integracao/rodizio/sabores?tipo=${tipo}`);
  },

  createRodizioSabor: async (data: {
    tipo: "salgada" | "doce";
    nome: string;
  }): Promise<RodizioSaborItem> => {
    return apiClient.post("/pizzaiolo-integracao/rodizio/sabores", data);
  },

  updateRodizioSabor: async (
    id: number,
    data: { nome: string }
  ): Promise<RodizioSaborItem> => {
    return apiClient.patch(`/pizzaiolo-integracao/rodizio/sabores/${id}`, data);
  },

  deleteRodizioSabor: async (id: number): Promise<void> => {
    await apiClient.delete(`/pizzaiolo-integracao/rodizio/sabores/${id}`);
  },

  reorderRodizioSabores: async (data: {
    tipo: "salgada" | "doce";
    ids: number[];
  }): Promise<RodizioSaborItem[]> => {
    return apiClient.put("/pizzaiolo-integracao/rodizio/sabores/reorder", data);
  },

  getRodizioEstado: async (lojaId?: number): Promise<RodizioEstadoResponse> => {
    const params = new URLSearchParams();
    if (lojaId != null) params.set("lojaId", String(lojaId));
    const qs = params.toString();
    return apiClient.get(
      `/pizzaiolo-integracao/rodizio/estado${qs ? `?${qs}` : ""}`
    );
  },

  resetRodizioSequencia: async (data: {
    tipo: "salgada" | "doce";
    lojaId?: number;
  }): Promise<RodizioEstadoResponse> => {
    return apiClient.post("/pizzaiolo-integracao/rodizio/sequencia/reset", data);
  },

  listRodizioUrgencias: async (
    tipo: "salgada" | "doce",
    lojaId?: number
  ): Promise<RodizioUrgenciaItem[]> => {
    const params = new URLSearchParams({ tipo });
    if (lojaId != null) params.set("lojaId", String(lojaId));
    return apiClient.get(
      `/pizzaiolo-integracao/rodizio/urgencias?${params.toString()}`
    );
  },

  criarRodizioUrgencia: async (data: {
    tipo: "salgada" | "doce";
    saborNome: string;
    lojaId?: number;
  }): Promise<RodizioUrgenciaItem> => {
    return apiClient.post("/pizzaiolo-integracao/rodizio/urgencia", data);
  },
};
